import twigVariables from "../../utils/twigVariables";

const twigVars = twigVariables();
const maintenance = document.getElementById("maintenances");

export default function checkMaintenance() {
	$.ajax({
		url: twigVars.maintenancecheckpath,
		dataType: "json",
		success: (data) => {
			if (!Array.isArray(data) || data.length === 0) {
				return;
			}

			let html = "";

			for (const text of data) {
				html += maintenanceTpl(text);
			}

			maintenance.innerHTML = html;
			maintenance.classList.remove("hide");
		},
	});
}

function maintenanceTpl(text) {
	return `
    <div class="bs-callout bs-callout-danger">
      <h4>Wartungsarbeiten</h4>
      <p>${text}</p>
    </div>
  `;
}
